import React, { FC } from 'react';
import styled from '@emotion/styled';

const HeaderBar = styled.div<{ color?: string; background?: string }>`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  background: ${(props) => props.background || 'var(--colorBlueGray100)'};
  font-family: Eina01-SemiBold;
  font-style: normal;
  font-weight: 600;
  font-size: 56px;
  text-align: center;
  color: ${(props) => props.color || 'var(--colorBlueGray1300)'};

  @media (orientation: portrait) {
    font-size: 48px;
  }
`;

const Logo = styled.img`
  position: absolute;
  top: 24px;
  left: 24px;
  height: 127px;
  width: auto;
  object-fit: contain;
  z-index: 1;

  @media (orientation: portrait) {
    top: 16px;
    left: 16px;
    height: 72px;
  }
`;

interface Props {
  /** Theme accent color used as the header background. */
  background?: string;
  /** Theme text color for the header labels. */
  color?: string;
  /** Optional brand logo overlaid above the header. */
  logoUrl?: string;
  /** Pre-translated label for the cooking column. Drilled from parent to avoid unnecessary re-renders. */
  preparingLabel: string;
  /** Pre-translated label for the ready column. Drilled from parent to avoid unnecessary re-renders. */
  readyLabel: string;
}

/**
 * Customer display header strip + brand logo.
 */
const Header: FC<Props> = ({ background, color, logoUrl, preparingLabel, readyLabel }) => (
  <>
    {logoUrl && <Logo src={logoUrl} alt="" />}
    <HeaderBar background={background} color={color}>
      <div>{preparingLabel}</div>
      <div>{readyLabel}</div>
    </HeaderBar>
  </>
);

export default React.memo(Header);
